/**
 * Created by razial on 2026-04-16.
 */

const RewardedPromotion = function (crossId) {
    this.crossId = crossId;
    this.tasks = [];
    this.completed = 0;
    this.claimed = 0;
    this.expectedReward = 0;
};

RewardedPromotion.GetProjectTitle = function (projectId) {
    const json = bundles.main.jsons.rewarded_promo_titles_json;
    const titles = json && json.getJson()[projectId] || {};
    return titles[cleverapps.settings.language] || titles.en || projectId;
};

RewardedPromotion.PlayerKey = function (sourceId, projectId) {
    return connector.platform.hasPublisherPlayerId() ? `${connector.platform.getUserID()}_${sourceId}_${projectId}` : undefined;
};

RewardedPromotion.prototype.updateData = function (data) {
    data = data || {};

    this.sourceId = data.sourceId;
    this.projectId = data.projectId;
    this.started = data.started || 0;
    this.finish = data.finish || 0;
    this.schedule = data.schedule;
    this.expectedReward = data.expectedReward || 0;
    this.completed = data.completed || 0;
    this.hostPayerTier = data.hostPayerTier;

    this.config = RewardedPromoConfig.PROJECTS[this.projectId];

    this.tasks = this.config.tasks.map((config) => new RewardedPromoTask(this, config));
};

// a record without finish was written before the schedule and stays open until its source game sets one
RewardedPromotion.prototype.isActive = function () {
    return this.started <= Date.now() && (!this.finish || Date.now() < this.finish);
};

RewardedPromotion.prototype.hasUnclaimedRewards = function () {
    const subtasksUnclaimed = this.tasks.slice(0, -1).some((task) => task.isCompleted() && !task.isClaimed());
    if (subtasksUnclaimed) {
        return true;
    }

    const lastTask = this.tasks[this.tasks.length - 1];
    return this.countCompletedTasks() === this.countAllTasks() && !lastTask.isClaimed();
};

RewardedPromotion.prototype.isFullyClaimed = function () {
    return this.countCompletedTasks() === this.countAllTasks()
        && this.tasks.every((task) => task.isClaimed());
};

RewardedPromotion.prototype.isEnded = function () {
    return this.started > 0 && !this.isActive();
};

RewardedPromotion.prototype.isConnected = function () {
    return !!(this.completed || this.claimed);
};

RewardedPromotion.prototype.getLink = function () {
    if (connector.platform.oneOf(connector.TEST)) {
        if (cleverapps.isLocalhost()) {
            return `${window.location.origin}/${this.projectId}/`;
        }

        if (cleverapps.config.debugMode) {
            return cleverapps.config.deployment.replace(cleverapps.config.name, this.projectId);
        }
    }

    const crossPromo = cleverapps.crossPromo.promotion.find((promo) => promo.id === this.projectId);
    return crossPromo && crossPromo.link;
};

RewardedPromotion.prototype.getPayload = function () {
    if (connector.platform.oneOf(connector.TEST)) {
        return {
            crossId: this.crossId
        };
    }

    const crossPromo = cleverapps.crossPromo.promotion.find((promo) => promo.id === this.projectId);
    const payload = crossPromo && crossPromo.payload || {};

    return {
        ...payload, crossId: this.crossId
    };
};

RewardedPromotion.prototype.getBundleName = function () {
    return this.config.bundle;
};

RewardedPromotion.prototype.getSidebarIconJson = function () {
    return bundles.sidebar.jsons[this.config.sidebarIcon];
};

RewardedPromotion.prototype.getTimeLeft = function () {
    return Math.max(this.finish - Date.now(), 0);
};

RewardedPromotion.prototype.getSourceName = function () {
    return RewardedPromotion.GetProjectTitle(this.sourceId);
};

RewardedPromotion.prototype.countAllTasks = function () {
    return this.tasks.length - 1;
};

RewardedPromotion.prototype.countCompletedTasks = function () {
    return this.tasks.slice(0, -1).filter((t) => t.isCompleted()).length;
};
